import React from 'react';

import TwoColumn from '../../components/TwoColumn';
import Main from './Main';

import './styles.css';

export default function TimeAttendance() {
  return (
    <TwoColumn>
      <TwoColumn.Left>
        <Main />
      </TwoColumn.Left>
      <TwoColumn.Right />
    </TwoColumn>
  );
}
